const SvgEditicon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
    fill="#6C737F"
      d="M18.952 1.083a3.578 3.578 0 0 0-5.06 0L1.94 13.035a3.106 3.106 0 0 0-.825 1.476L.02 19.113a.75.75 0 0 0 .904.903l4.601-1.096a3.105 3.105 0 0 0 1.477-.825l11.95-11.95a3.578 3.578 0 0 0 0-5.06v-.002Zm-4 1.06a2.08 2.08 0 0 1 2.94 2.94L17 5.974l-2.94-2.939.892-.89v-.002ZM13 4.097l2.94 2.938-10 10c-.21.21-.474.357-.763.426l-3.416.814.813-3.416c.07-.29.217-.554.427-.764l10-10v.002Z"
    />
  </svg>
);
export default SvgEditicon;